import { Inbox, Session } from "talkjs/all";
import { Project, Role } from "../../proto/api_pb";
import { Dispatch, SetStateAction } from "react";
export interface ProjectsType {
    session: Session | undefined;
    setInbox: Dispatch<SetStateAction<Inbox | undefined>>;
    openFoldersList?: OpenFoldersListType[]
    setOpenFoldersList?: Dispatch<SetStateAction<OpenFoldersListType[]>>
}


export interface ProjectsFilterMenuProps {
    userNames: string[];
    setSelectedCollaborators: Dispatch<SetStateAction<string[] | undefined>>
    setProjects: Dispatch<SetStateAction<Project[]>>;
    setPage: Dispatch<SetStateAction<number>>;
    selectedCollaborators: string[] | undefined
}

export interface ProjectFileFilterMenuProps {
    filter: string;
    setFilter: Dispatch<SetStateAction<string>>;
}

export function getRoleNumber(role: string): number {
    switch (role.toLowerCase()) {
        case "artist":
            return Role.ROLE_ARTIST;
        case "manager":
            return Role.ROLE_MANAGER;
        case "admin":
            return Role.ROLE_ADMIN;
        case "Admin":
            return Role.ROLE_ADMIN;
        case "Manager":
            return Role.ROLE_MANAGER;
        case "Artist":
            return Role.ROLE_ARTIST;
        default:
            return 0;
    }
}
export function getRoleString(roleNumber: number): string {
    switch (roleNumber) {
        case Role.ROLE_ARTIST:
            return "Artist";
        case Role.ROLE_MANAGER:
            return "Manager";
        case Role.ROLE_ADMIN:
            return "Admin";
        default:
            return "";
    }
}


export interface OpenFoldersListType {
    id: string;
    name: string
}